import { Shield, Crosshair, ListChecks, Lightning } from "@phosphor-icons/react";
import { useInView } from "@/hooks/useInView";

const reasons = [
  { icon: Shield, title: "Trauma-Informed Instruction", desc: "Coaching rooted in nervous system regulation, boundary-setting, and situational awareness \u2014 not aggression, but composure under pressure." },
  { icon: Crosshair, title: "Practical Physical Confidence", desc: "Real self-defense skill that's structured, repeatable, and designed for real-world scenarios \u2014 from the workplace to everyday life." },
  { icon: ListChecks, title: "Structured, Repeatable Methodology", desc: "ARRP, DCAE, and 4D provide a proven framework so every program is progressive, teachable, and tailored to who's in the room." },
  { icon: Shield, title: "Composure Under Pressure", desc: "Regulated presence, clear thinking, and decisive action when it matters \u2014 in training and everyday life." },
  { icon: Crosshair, title: "Situational Awareness & Boundaries", desc: "Read environments, set clear boundaries, and communicate strategically so you stay ahead of trouble instead of reacting to it." },
  { icon: Lightning, title: "Beyond the Training Floor", desc: "Strength that carries into leadership, family, career, and community \u2014 age-appropriate and audience-specific instruction for every group." },
];

const WHY_IMG = "https://static.prod-images.emergentagent.com/jobs/117cf0fb-3794-49a5-86c5-1fbf8d876a37/images/747ecdc5853b568671146cb25fbac0b83a84a4305de907fc243237ea9417d8a1.png";

export default function WhySection() {
  const [ref, inView] = useInView();

  return (
    <section id="why" data-testid="why-section" className="bg-[#050505] py-16 sm:py-20" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <p className={`text-xs tracking-[0.2em] uppercase font-bold text-[#D4AF37] font-body mb-4 reveal ${inView ? 'visible' : ''}`}>Why 3SM</p>
        <h2 className={`font-heading text-3xl sm:text-4xl font-bold tracking-tight text-[#F2EFE9] mb-10 max-w-lg reveal ${inView ? 'visible' : ''} stagger-1`}>
          More than a workout.
        </h2>
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {reasons.map((r, i) => (
            <div
              key={r.title}
              data-testid={`why-card-${r.title.toLowerCase().replace(/\s/g, '-')}`}
              className={`glass-card border border-white/10 p-6 rounded-lg hover:border-[#D4AF37]/40 transition-all hover:-translate-y-1 group reveal-scale ${inView ? 'visible' : ''} stagger-${(i % 4) + 1}`}
            >
              <div className="animate-float">
                <r.icon size={26} weight="duotone" className="text-[#D4AF37] mb-4" />
              </div>
              <h3 className="font-heading text-base font-semibold text-[#F2EFE9] mb-2">{r.title}</h3>
              <p className="text-sm text-[#8C8C8C] font-body leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
        <div className={`border-l-2 border-[#D4AF37]/50 pl-5 max-w-3xl reveal ${inView ? 'visible' : ''} stagger-2`}>
          <p className="text-[#F2EFE9] font-heading text-lg sm:text-xl font-semibold italic leading-snug">
            &ldquo;3SM is not built around aggression. It is built around awareness, composure, responsible action, and confidence that can be used in real life.&rdquo;
          </p>
        </div>
      </div>
    </section>
  );
}
